<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData" :custom-create-actions="[listMenus]"
                     :selected-data="selectedMenu" @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedMenu" :table-columns="tableColumns" :collection-data="collectionData"
                    :custom-update-actions="[listMenus]" :auth-token="authToken" :list-api="listApi" @updateValues="setupUpdateValues"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedMenu" :load-data="loadDataMenu"
                           :entity="entity" :auth-token="authToken" :list-api="listApi" :queries="queries"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataMenu" :parentView="view" :collectionMenus="collectionMenus" @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import MenusCrearActualizarComponent from "@/components/auth/components/MenusCrearActualizarComponent";
import {useLayoutMain, listCollectionData} from "@/layouts/main";

export default {
  name: 'MenuCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    MenusCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Menus',
      entity: {gender: 'm', value: 'menu'},
      childFormComponent: 'menusCrearActualizarComponent',
      tableColumns: {
        "id": {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: "ID",
        },
        'alias': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Alias",
        },
        'name': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Nombre",
        },
        "menu.name": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Menú padre",
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: "Fecha de creación",
        },
      },
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const collectionMenus = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedMenu = ref({
      id : '',
      alias: '',
      name: '',
      menu_padre_id: '',
      estado: '',
    });
    const loadDataMenu = ref({
      alias: '',
      name: '',
      menu_padre_id: '',
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_MENU_CREATE,
      list: process.env.VUE_APP_NEST_MENU_FINDALL,
      update: process.env.VUE_APP_NEST_MENU_UPDATE,
      updateState: process.env.VUE_APP_NEST_MENU_UPDATESTATE
    });
    const listMenus = async () => await listCollectionData(process.env.VUE_APP_NEST_MENU_FINDALL, {'collectionMenus': collectionMenus}, authToken.value, undefined, undefined, undefined, undefined, undefined, 'table.nivel = 1', false);
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedMenu, loadDataMenu, listApi);
    return {
      view,
      collectionData,
      collectionMenus,
      authToken,
      selectedMenu,
      loadDataMenu,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      listMenus
    };
  }
}
</script>